import { claudeModelName } from '@/features/llm-profiles/claudeModelCatalog';
import type { BreakdownEntry } from '@/lib/api/generated/model';

/**
 * A by-model row's name (spec 217): the name the admin chose the model by, as on the
 * profile card and the AI models page, or the service's label — the id as recorded,
 * or "Unknown model" for runs that recorded none.
 */
export function modelBreakdownLabel(entry: BreakdownEntry): string {
  return (
    (entry.key === null ? undefined : claudeModelName(entry.key)) ?? entry.label
  );
}
